import HARDCODE from '../../business-const/HardCode/HardCode'

import LABEL from '../../business-const/Label/Label'



const tabAcompanhamentoFormList = (jsonAcessoCliente, modoInteracaoCliente, linhaTipoLicenca) => {

    let cont = HARDCODE.codePoint_a
    
    const tabAcompanhamentoFormListAux = [
        String.fromCodePoint(cont++) + ') ' + LABEL.tabAcompanhamentoFormListPendencias,
    ]

    if (!jsonAcessoCliente.acessoCliente) {

        tabAcompanhamentoFormListAux.push(
            String.fromCodePoint(cont++) + ') ' + LABEL.tabAcompanhamentoFormListFunisEtapas,
        )
    }

    if (!jsonAcessoCliente.acessoCliente && !modoInteracaoCliente) {

        tabAcompanhamentoFormListAux.push(
            String.fromCodePoint(cont++) + ') ' + LABEL.tabAcompanhamentoFormListAnotacoes,
        )
    }

    if (linhaTipoLicenca.exibirSomenteConsorcio === 'N') {

        tabAcompanhamentoFormListAux.push(
            String.fromCodePoint(cont++) + ') ' + LABEL.tabAcompanhamentoFormListAportes,
        )
    }

    if (!jsonAcessoCliente.acessoCliente) {
        
        tabAcompanhamentoFormListAux.push(
            String.fromCodePoint(cont++) + ') ' + LABEL.tabAcompanhamentoFormListConsorcio,
        )

        if (linhaTipoLicenca.exibirSomenteConsorcio === 'N') {

            tabAcompanhamentoFormListAux.push(
                String.fromCodePoint(cont++) + ') ' + LABEL.tabAcompanhamentoFormListSeguroVida,
            )
        }
    }

    tabAcompanhamentoFormListAux.push(
        String.fromCodePoint(cont++) + ') ' + LABEL.tabAcompanhamentoFormListArquivo,
    )

    return tabAcompanhamentoFormListAux
}

export default tabAcompanhamentoFormList